import type { Comment, PaginatedCommentsResponse } from '@/types/comment';
import type { CommentWire, PaginatedCommentsResponseWire } from '../schemas/comment';

/**
 * Convert a single comment from wire format to domain format
 */
export function mapCommentWireToDomain(wire: CommentWire): Comment {
  return {
    id: wire.id,
    checkInId: wire.check_in_id,
    userId: wire.user_id,
    content: wire.content,
    createdAt: wire.created_at,
    updatedAt: wire.updated_at,
    user: {
      id: wire.user.id,
      username: wire.user.username,
      displayName: wire.user.display_name,
      avatarUrl: wire.user.avatar_url,
    },
  };
}

/**
 * Convert paginated comments response from wire format to domain format
 */
export function mapPaginatedCommentsWireToDomain(
  wire: PaginatedCommentsResponseWire
): PaginatedCommentsResponse {
  return {
    items: wire.items.map(mapCommentWireToDomain),
    total: wire.total,
    page: wire.page,
    perPage: wire.per_page,
    totalPages: wire.total_pages,
  };
}
